<template>
  <div>
    <!-- START - Justificativa obrigatória para corridas -->
    <div
      v-if="claims.company['ROLE_GET_COMPANY_ID_CONFIG'] || claims.company['ROLE_PUT_COMPANY_ID_CONFIG']"
      class="switch"
    >
      <div class="switch__content">
        <div class="switch__header">
          <img class="subtitle__icon" src="@/assets/icons/ico_lock-accent.svg" alt="">
          <h2 class="switch__title">{{ $t(`${namespace}.rationaleForRunningTitle`) }}</h2>
        </div>

        <div
          v-if="claims.company['ROLE_PUT_COMPANY_ID_CONFIG']"
          class="switch__sub-header"
          style="border-bottom: 1px solid #F0F0F0; border-top: none;"
        >
          <div class="switch__text">
            <p class="switch__subtitle">{{ $t(`${namespace}.rationaleForRunningSubtitle`) }}</p>
            <p class="switch__desc">{{ $t(`${namespace}.rationaleForRunningDesc`) }}</p>
          </div>

          <a
            v-if="editRationaleForRunning"
            href="#"
            class="switch__edit text--link accent--text"
            @click.prevent="toggleRationaleForRunning = false; editRationaleForRunning = false; switchRationaleForRunning = true"
          >
            {{ $t('Common.edit') }}
          </a>
          <v-switch v-model="switchRationaleForRunning" color="success" />
        </div>

        <!-- <div v-if="claims.company['ROLE_GET_COMPANY_ID_CONFIG'] && switchRationaleForRunning" class="switch__body"> -->
        <div
          v-if="claims.company['ROLE_GET_COMPANY_ID_CONFIG'] && switchRationaleForRunning"
          class="switch__body"
          style="border: none;"
        >
          <div v-if="toggleRationaleForRunning" class="switch__edit-box">
            <v-layout>
              <v-flex xs-6>
                <p class="mb-0">{{ $t(`${namespace}.rationaleForRunningJustifyRequired`) }}</p>
                <span>{{ companyConfig.showNote ? $t(`${namespace}.rationaleForRunningYes`) : $t(`${namespace}.rationaleForRunningNo`) }}</span>
              </v-flex>

              <v-flex xs-6>
                <p class="mb-0">{{ $t(`${namespace}.rationaleForRunningLimitChars`) }}</p>
                <span>{{ companyConfig.minNoteLength }} {{ $t(`${namespace}.rationaleForRunningThe`) }} {{ companyConfig.maxNoteLength }} {{ $t(`${namespace}.rationaleForRunningChars`) }}</span>
              </v-flex>
            </v-layout>
          </div>

          <RationaleForRunning
            v-else
            :companyConfig="companyConfig"
            :status="companyConfigStatus"
            @tryAgain="getConfig"
            @success="getConfig"
            @close="getConfig"
          />
        </div>
      </div>
    </div>
    <!-- END - Justificativa obrigatória para corridas -->

    <!-- 强制公司叫车时填写project的开关 -->
    <ProjectsMandatory :data="companyConfig"/>

    <!-- START - Envio de recibo de corridas -->
    <!-- v-if="claims.company['ROLE_PUT_COMPANY_ID_CONFIG']" -->
    <ReceiptsSmsVoucher :data="companyConfig" />
    <!-- END - Envio de recibo de corridas -->

    <!-- START - Limite diário de créditos para a empresa -->
    <div v-if="claims.ui['UI_VIEW_DAILY_LIMIT']" class="switch">
      <div class="switch__content">
        <div class="switch__header">
          <img class="subtitle__icon" src="@/assets/icons/ico_lock-accent.svg" alt="">
          <h2 class="switch__title">{{ $t(`${namespace}.dailyLimitOfCreditsTitle`) }}</h2>
        </div>

        <div
          v-if="claims.profiles['ROLE_ADMINISTRATOR'] || claims.profiles['ROLE_FINANCIAL_ADMIN']"
          class="switch__sub-header"
        >
          <div class="switch__text">
            <p class="switch__subtitle">{{ $t(`${namespace}.dailyLimitOfCreditsSubtitle`) }}</p>
            <p class="switch__desc">{{ $t(`${namespace}.dailyLimitOfCreditsDesc`) }}</p>
          </div>

          <a
            v-if="claims.profiles['ROLE_ADMINISTRATOR'] && editDailyLimitOfCredits"
            href="#"
            class="switch__edit text--link accent--text"
            @click.prevent="toggleDailyLimitOfCredits = false; editDailyLimitOfCredits = false; switchDailyLimitOfCredits = true"
          >
            {{ $t('Common.edit') }}
          </a>
          <v-switch v-if="claims.profiles['ROLE_ADMINISTRATOR']" v-model="switchDailyLimitOfCredits" color="success" />
        </div>

        <div
          v-if="claims.ui['UI_VIEW_DAILY_LIMIT'] && switchDailyLimitOfCredits"
          class="switch__body"
          :class="{ 'switch__body--no-border': !claims.profiles['ROLE_ADMINISTRATOR'] && !claims.profiles['ROLE_FINANCIAL_ADMIN'] }"
        >
          <div v-if="toggleDailyLimitOfCredits" class="switch__edit-box">
            <p class="mb-0">{{ $t(`${namespace}.dailyLimitOfCreditsText`) }}</p>
            <span>{{ financialConfig | currencyBRL }}</span>
          </div>

          <DailyLimitOfCredits
            v-else
            :financialConfig="financialConfig"
            :status="financialConfigStatus"
            @tryAgain="getFinancialConfig"
            @success="getFinancialConfig"
            @close="getFinancialConfig"
          />
        </div>
      </div>
    </div>
    <!-- END - Limite diário de créditos para a empresa -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RationaleForRunning from 'components/usagePolicies/RationaleForRunning'
import DailyLimitOfCredits from 'components/usagePolicies/DailyLimitOfCredits'
import ReceiptsSmsVoucher from 'components/usagePolicies/ReceiptsSmsVoucher'
import ProjectsMandatory from 'components/usagePolicies/ProjectsMandatory'

export default {
  name: 'UsagePoliciesPageContent',
  components: {
    RationaleForRunning,
    DailyLimitOfCredits,
    ReceiptsSmsVoucher,
    ProjectsMandatory
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: state => state.mainMenu.isOpen,
      company: state => state.company.selectedCompany,
      claims: state => state.userClaims.claims
    }),

    routeId () {
      if (this.$route.params.id) {
        return Number(this.$route.params.id)
      }

      if (this.company) {
        return this.company.id
      }

      return null
    }
  },
  data () {
    return {
      namespace: 'Views.UsagePoliciesPage',
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'UsagePolicies', title: this.$t('Views.UsagePoliciesPage.title') }
      ],
      switchRationaleForRunning: false,
      editRationaleForRunning: false,
      toggleRationaleForRunning: false,
      switchDailyLimitOfCredits: false,
      editDailyLimitOfCredits: false,
      toggleDailyLimitOfCredits: false,
      switchUsePoliciesByTime: true,

      // data
      companyConfig: null,
      companyConfigStatus: null,
      financialConfig: null,
      financialConfigStatus: null
    }
  },
  methods: {
    async getConfig () {
      this.companyConfigStatus = 'loading'
      this.switchRationaleForRunning = false
      this.editRationaleForRunning = false
      this.toggleRationaleForRunning = false

      try {
        const { data: res } = await this.$apiService.getCompanyConfig(this.routeId)
        this.companyConfig = res.data

        if (this.companyConfig.minNoteLength >= 0 && (this.companyConfig.maxNoteLength === 1024 || this.companyConfig.maxNoteLength !== 1024)) {
          this.switchRationaleForRunning = true
          this.editRationaleForRunning = true
          this.toggleRationaleForRunning = true
        }

        this.companyConfigStatus = 'success'
      } catch (err) {
        console.log('Error', err)
        this.companyConfigStatus = 'error'
      }
    },

    async getFinancialConfig (companyId) {
      this.financialConfigStatus = 'loading'
      this.switchDailyLimitOfCredits = false
      this.editDailyLimitOfCredits = false
      this.toggleDailyLimitOfCredits = false

      try {
        const { data: res } = await this.$apiService.getCompanyFinancialConfig(this.routeId)
        this.financialConfig = res.data.budgetLimit

        if (this.financialConfig > 0) {
          this.switchDailyLimitOfCredits = true
          this.editDailyLimitOfCredits = true
          this.toggleDailyLimitOfCredits = true
        }

        this.financialConfigStatus = 'success'
      } catch (err) {
        console.log('Error', err)
        this.financialConfigStatus = 'error'
      }
    }
  },
  mounted () {
    if (this.claims.company['ROLE_GET_COMPANY_ID_CONFIG']) {
      this.getConfig()
    }

    if (this.claims.company['ROLE_GET_COMPANY_ID_FINANCIALCONFIG']) {
      this.getFinancialConfig()
    }
  }
}
</script>

<style lang="scss" scoped>
.switch {
  margin-bottom: 24px;
  padding: 0 16px;
}

.switch__content {
  background-color: #fff;
  border: 1px solid $gray-2;
  max-width: 840px;
  transition: box-shadow .26s;

  &:hover {

    @media (min-width: 992px) {
      box-shadow: 0 1px 6px rgba(#000, .25);
    }
  }
}

.switch__header {
  border-bottom: 1px solid $gray-2;
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  padding: 18px 24px;

  .switch__subtitle {
    font-size: 12px;
    font-weight: normal;
    text-transform: none;
  }
}

.subtitle__icon,
.switch__title {
  display: inline-block;
  vertical-align: middle;
}

.subtitle__icon {
  margin-right: 10px;
  width: 24px;
}

.switch__title {
  font-size: 18px;
  font-weight: 800;
}

.switch__sub-header {
  padding: 16px;
  position: relative;

  .switch__text {
    padding-right: 95px;
  }

  .switch__edit {
    position: absolute;
    right: 66px;
    top: 50%;
    transform: translateY(-50%);
  }

  .v-input--switch {
    position: absolute;
    right: 8px;
    top: 45%;
    transform: translateY(-50%);
  }
}

.switch__subtitle,
.switch__desc {
  margin-bottom: 0
}

.switch__subtitle {
  font-size: 14px;
}

.switch__desc {
  color: $gray-6;
  font-size: 12px;
}

.switch__body {
  border-bottom: none;
  border-top: 1px solid $gray-2;
  background-color: #fff;
  padding: 16px;

  &.switch__body--no-border {
    border: none;
  }
}

.switch__edit-box {

  span {
    color: #757575;
  }
}
</style>

<style lang="scss">
.usage-policies-view {

  .switch__header {

    .v-input--selection-controls {
      margin-top: 0;
    }

    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
      margin-bottom: 5px;
    }

    .v-messages.theme--light {
      display: none;
    }
  }
}
</style>
